import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { JOURNAL } from "@/lib/content";

export default function Journal() {
  return (
    <section id="journal" className="relative bg-surface py-28 md:py-40 border-t border-white/10" data-testid="journal">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <Reveal>
              <Overline>Journal</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif font-light text-ink text-4xl md:text-6xl lg:text-7xl leading-[1]">
                Notes on <em className="italic text-metallic-gold">quiet hospitality</em>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <span className="font-sans text-xs tracking-[0.2em] uppercase text-ash">
              Coming soon
            </span>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {JOURNAL.map((j, i) => (
            <Reveal key={j.title} delay={(i % 3) * 0.08}>
              <motion.article
                data-testid={`journal-${i}`}
                className="group bg-surface p-8 md:p-10 h-full flex flex-col justify-between min-h-[240px] cursor-default"
                whileHover={{ backgroundColor: "#161512" }}
                transition={{ duration: 0.4 }}
              >
                <div className="flex items-center justify-between">
                  <span className="font-sans text-[0.65rem] tracking-[0.2em] uppercase text-gold">
                    {j.tag}
                  </span>
                  <span className="font-sans text-xs text-faint">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-10 font-serif font-light text-ink text-2xl md:text-3xl leading-tight group-hover:text-gold transition-colors duration-300">
                  {j.title}
                </h3>
                <span className="mt-6 font-sans text-xs tracking-[0.15em] uppercase text-ash">
                  Read soon →
                </span>
              </motion.article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
